import { SURVEY_INTEGRATIONS, INTEGRATIONS_DATA } from "@/consts/integrations";
import { i18n } from "@/boot/i18n";
import * as types from "./mutationTypes";

export default {
  async getSurveyIntegrations({ commit, dispatch }, integrations) {
    const integrationsList = integrations.filter(
      (integration) => SURVEY_INTEGRATIONS.includes(integration.id) && integration.enabled
    );
    let surveyIntegrations = [];

    if (integrationsList.length) {
      const integrationsKind = integrationsList.reduce((list, item) => {
        return list.includes(item.id) ? list : [...list, item.id];
      }, []);

      for (const kind of integrationsKind) {
        surveyIntegrations = surveyIntegrations.concat({
          id: kind,
          name: INTEGRATIONS_DATA[kind].name,
          description: i18n.t(INTEGRATIONS_DATA[kind].survey_description),
          integrations: [
            {
              label: i18n.t("survey.new.integrations.select_label"),
              value: ""
            }
          ].concat(formatIntegrations(integrationsList.filter((integration) => integration.id === kind)))
        });
        await dispatch("checkIntegrationDefault", surveyIntegrations[surveyIntegrations.length - 1].integrations);
      }
    }
    commit(types.SET_INTEGRATIONS, surveyIntegrations);
  },
  setIntegration({ commit }, integrationUUID) {
    commit(types.SET_INTEGRATION, integrationUUID);
  },
  clearSurveyIntegrations({ commit }) {
    commit(types.CLEAR_INTEGRATIONS);
  },
  checkIntegrationDefault({ state, dispatch }, integrations) {
    for (const integration of integrations) {
      if (integration.default && !state.survey.zendesk_integration_uuid) {
        dispatch("setIntegration", integration.value);
        return;
      }
    }
  }
};

const formatIntegrations = (integrations) => {
  return integrations.map((integration) => {
    return { value: integration.uuid, label: integration.name, default: !!integration.default_uuid };
  });
};
